import React from 'react';

import { Box } from '@mui/material';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';

import { COLOR_PRIMARY_2 } from 'src/colors';

const SearchButton = ({ setIsMobileSearchBarOpen }) => {
  return (
    <Box
      sx={{
        width: 38,
        height: 38,
        borderRadius: 200,
        border: `4px solid ${COLOR_PRIMARY_2}`,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: COLOR_PRIMARY_2,
      }}
    >
      <SearchRoundedIcon
        sx={{
          width: 30,
          height: 30,
          cursor: 'pointer',
          color: '#fff',
        }}
        onClick={() => setIsMobileSearchBarOpen(true)}
      />
    </Box>
  );
};

export default SearchButton;
